import { Component, OnInit } from '@angular/core';
import { IToastGlobalConfiguration } from '@clavisco/alerts';
import { Repository, Structures } from '@clavisco/core';
import { Login } from '@clavisco/login';
import { ITableGlobalConfiguration } from '@clavisco/table';
import { environment } from 'src/environments/environment';
import * as LogRocket from 'logrocket';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'cl_fp_mlt_isv';
  ApiUrl = environment.apiUrl;

  constructor(){
    if (environment.logrocket) {
      LogRocket.init(environment.logrocket);
    }
  }

  ngOnInit(){
    Repository.Behavior.SetTokenConfiguration({
      token: 'Shared',
      setting: 'apiUrl',
      value: this.ApiUrl
   });

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'overlaysConfiguration',
      value: JSON.stringify({
        loginMessage: 'Iniciando Sesión',
        changePasswordMessage: 'Cambiando Contraseña',
        sendRecoverEmailMessage: 'Enviando Correo de Recuperación',
        recoverPasswordMessage: 'Actualizando Contraseña'
      } as Login.Structures.IOverlaysGlobalConfiguration)
    });

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'changePassword',
      value: {
        endpointToRequest: `Users/ChangePassword`
      } as Login.Structures.IChangePasswordConfig
    })

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'recoverPassword',
      value: {
        endpointToRequest: `Users/ChangeRecoveryPassword`
      } as Login.Structures.IChangePasswordConfig
    })

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'sendRecoverPasswordEmail',
      value: {
        urlVariableToReplaceWithEmail: '#EMAIL',
        endpointToRequest: `Users/#EMAIL/RecoveryPassword`
      } as Login.Structures.ISendRecoverPasswordEmailConfig
    })


    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.ALERTS,
      settings: {
        duration: 8000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        cssClasses: ['alert-text']
      } as IToastGlobalConfiguration,
      override: true
    });

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.TABL,
      settings: {
        backgroundTransparent: true
      } as ITableGlobalConfiguration
    });

    Repository.Behavior.SetTokenConfiguration({ token: 'NotificationCenter', setting: 'max', value: '10' });
  }
}
